import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './PageNavbar.css'; // Use a specific CSS file for PageNavbar
import logo from '../images/logo.webp';
import MenuIcon from '@mui/icons-material/Menu'; // Material UI hamburger icon
import CloseIcon from '@mui/icons-material/Close'; // Material UI close icon

const PageNavbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
    document.body.style.overflow = menuOpen ? 'auto' : 'hidden'; // Prevent page scrolling when menu is open
  };

  return (
    <nav className="page-navbar">
      <div className="page-navbar-content">
        <div className="page-navbar-logo">
          <Link to="/">
            <img src={logo} alt="Logo" />
          </Link>
        </div>
        {/* Links displayed on desktop */}
        <div className="page-navbar-links-desktop">
          <Link to="/">INICIO</Link>
          <Link to="/productos">PRODUCTOS</Link>
          <Link to="/servicios">SERVICIOS</Link>
          <Link to="/ofertalaboral">OFERTA LABORAL</Link>
          <Link to="/nosotros">NOSOTROS</Link>
          <Link to="/contacto">CONTACTO</Link>
        </div>
        {/* Hamburger icon for mobile */}
        <div className="page-navbar-hamburger" onClick={toggleMenu}>
          {menuOpen ? (
            <CloseIcon className="hamburger-icon" />
          ) : (
            <MenuIcon className="hamburger-icon" />
          )}
        </div>
        {/* Fullscreen menu for mobile */}
        <div className={`page-navbar-menu ${menuOpen ? 'open' : ''}`}>
          <div className="page-navbar-links-mobile">
            <Link to="/" onClick={toggleMenu}>INICIO</Link>
            <Link to="/productos" onClick={toggleMenu}>PRODUCTOS</Link>
            <Link to="/servicios">SERVICIOS</Link>
            <Link to="/ofertalaboral">OFERTA LABORAL</Link>
            <Link to="/nosotros">NOSOTROS</Link>
            <Link to="/contacto" onClick={toggleMenu}>CONTACTO</Link>
          </div>
          {/* Close button in full screen menu */}
          <button className="page-navbar-close-btn" onClick={toggleMenu}>
            <CloseIcon />
          </button>
        </div>
      </div>
    </nav>
  );
};

export default PageNavbar;
